module.exports = __webpack_public_path__ + "static/img/engb2.d3cb5bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/engb2.png
// module id = 8hoJ
// module chunks = 0